import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import ResultsContainer from './results';
import SearchContainer from './search';

export class BOWPage extends PureComponent {
	static propTypes = {
		bowCurrentYear: PropTypes.string.isRequired,
		categories: PropTypes.array.isRequired,
		initialLocation: PropTypes.object.isRequired,
	};

	render() {
		return (
			<React.Fragment>
				<SearchContainer
					bowCurrentYear={this.props.bowCurrentYear}
					categories={this.props.categories}
					initialLocation={this.props.initialLocation}
				/>
				<ResultsContainer />
			</React.Fragment>
		);
	}
}

/** @internal */
export function mapStateToProps(state) {
	return {
		categories: state.categories,
		bowCurrentYear: state.bow.currentYear,
		initialLocation: state.location,
	};
}

const enhancedBOW = compose(connect(mapStateToProps));

export default enhancedBOW(BOWPage);
